import axios from "axios";

const baseURL = "/api/cdk/terminal/v1";

const URL = {
  listMerchants: `${baseURL}/list/merchants`,
  list: `${baseURL}/list`
};

const HEADERS = {
  "Content-Type": "application/json"
};

const TerminalsService = {
  getMerchants: async () => {
    const response = await axios.get(`${URL.listMerchants}`, {
      headers: HEADERS
    });
    return response.data;
  },
  getTerminals: async () => {
    const response = await axios.get(`${URL.list}`, { headers: HEADERS });
    return response.data;
  },
  getTerminal: async id => {
    const response = await axios.get(`${baseURL}/${id}`, { headers: HEADERS });
    return response.data;
  },
  createTerminal: async terminal => {
    const response = await axios.post(`${baseURL}/`, terminal, {
      headers: HEADERS
    });
    return response.data;
  },
  updateTerminal: async terminal => {
    const response = await axios.put(`${baseURL}/`, terminal, {
      headers: HEADERS
    });
    return response.data;
  },
  deleteTerminal: async terminal => {
    const { id } = terminal;
    const response = await axios.delete(`${baseURL}/${id}`, {
      headers: HEADERS
    });
    return response.data;
  }
};

export default TerminalsService;
